import homeTpl from './views/people-search.html';
import homeCtrl from './controllers/peoplelookupController';
import './people-look-up.scss';
var module = angular.module('peopleSearch', [
    //import modules
])
.controller('peopleSearch', homeCtrl);


// import './manageReportsModule.scss';
// module.config(function($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('peopleSearch', {
//             parent: 'app',
//             url: '/people-search',
//             views: {
//                 '@': {
//                     template: homeTpl,
//                     controller: homeCtrl,
//                     controllerAs: 'peopleSearch'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/people_lookup/peoplelookupModule.js